module.exports = __webpack_public_path__ + "img/battery_outline.5c59c761.svg";